<template>
  <div>
    <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>

    <v-card v-if="data_loaded">
      <v-card-title>
        <v-icon x-large>corporate_fare</v-icon>
        <h1 class="ms-3">עסקים</h1>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          class="text-center"
          :headers="headers"
          :items="items"
          mobile-breakpoint="0"
        >
          <template v-slot:item="{ item }">
            <tr @click="edit_row(item)">
              <td>{{ item.name }}</td>
              <td>{{ item.id_number }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.company_phone }}</td>
              <td>{{ item.fax || "_" }}</td>
              <td>{{ item.country || "-" }}</td>
              <td>{{ item.address || "_" }}</td>
              <td>
                <v-chip
                  x-small
                  class="px-2"
                  :color="item.status ? 'success black--text' : 'error'"
                >
                  {{ item.status ? "פעיל" : "לא פעיל" }}
                </v-chip>
              </td>

              <td>{{ item.created_at }}</td>
            </tr>

            <tr v-if="item.form" class="grey lighten-3">
              <td colspan="10" class="pt-3">
                <v-form :ref="`form_${item.id}`">
                  <v-row class="basic mt-2">
                    <v-col class="py-0">
                      <v-text-field
                        @keydown="input_change(item, 'name_exist')"
                        background-color="white"
                        outlined
                        dense
                        v-model="item.name"
                        :rules="[
                          (v) => !!v || 'שדה חובה',
                          !item.name_exist || 'שדה חובה',
                        ]"
                      >
                        <template slot="label">
                          <strong class="red--text">*</strong>
                          שם
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        outlined
                        dense
                        v-model="item.company_phone"
                        :rules="[
                          (v) => !!v || 'שדה חובה',
                          !item.company_phone_exist || 'שדה חובה',
                        ]"
                      >
                        <template slot="label">
                          <strong class="red--text">*</strong>
                          מספר טלפון
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        outlined
                        dense
                        v-model="item.id_number"
                        :rules="[
                          (v) => !!v || 'שדה חובה',
                          !item.id_number_exist || 'שדה חובה',
                        ]"
                      >
                        <template slot="label">
                          <strong class="red--text">*</strong>
                          ח.ט
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        outlined
                        dense
                        v-model="item.email"
                        :rules="[
                          (v) => !!v || 'שדה חובה',
                          !item.email_exist || 'שדה חובה',
                        ]"
                      >
                        <template slot="label">
                          <strong class="red--text">*</strong>
                          מייל
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        outlined
                        dense
                        label="עיר"
                        v-model="item.country"
                      ></v-text-field>
                    </v-col>

                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        outlined
                        dense
                        label="כתובת"
                        v-model="item.address"
                      ></v-text-field>
                    </v-col>
                    <v-col class="py-0">
                      <v-text-field
                        background-color="white"
                        readonly
                        outlined
                        dense
                        label="סטטוס"
                        :value="item.status ? 'פעיל' : 'לא פעיל'"
                      >
                        <template slot="append">
                          <v-switch
                            v-model="item.status"
                            class="mt-0"
                            hide-details
                          ></v-switch>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-checkbox
                        @change="select_all_permissions(item, $event)"
                        color="green"
                        :input-value="
                          item.permissions.length == permissions.length
                        "
                        label="تحديد الكل"
                      ></v-checkbox>
                      <v-divider></v-divider>
                      <div class="d-flex flex-wrap white">
                        <v-checkbox
                          v-for="(per, i) in permissions"
                          :key="i"
                          :label="`${i} - ${per.text}`"
                          :value="per.value"
                          v-model="item.permissions"
                          class="ms-5"
                        ></v-checkbox>
                      </div>
                    </v-col>

                    <v-col class="py-0 d-flex justify-space-between mb-5">
                      <v-btn
                        depressed
                        height="40"
                        width="59%"
                        :loading="item.save_loader"
                        :disabled="item.save_loader"
                        color="black white--text"
                        @click="save_update(item)"
                        >שמירה</v-btn
                      >
                      <v-btn
                        @click="delete_row(item.id)"
                        depressed
                        height="40"
                        width="35%"
                        color="white "
                      >
                        <v-icon color="black">delete_sweep </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-snackbar color="#333" left v-model="snackbar_success">
      <p class="white--text font-weight-bold">تم التعديل بنجاح</p>
      <template v-slot:action>
        <v-icon color="success" class="ms-3">check_circle</v-icon>
      </template>
    </v-snackbar>

    <DeleteDialog
      @delete_done="get_data()"
      @close_delete="delete_obj.delete_prop = false"
      :delete_obj="delete_obj"
    ></DeleteDialog>
  </div>
</template>

<script>
import DeleteDialog from "@/components/public/delete";
import permissions_data from "../../../data/permiassions";
export default {
  props: ["data_loaded"],
  name: "Table",
  data() {
    return {
      permissions: permissions_data,
      permissions_values: [],
      snackbar_success: false,
      delete_obj: {
        delete_prop: false,
        delete_url: "super/companies",
        title: "מחיקת עמותה",
        id: null,
      },
      features: [],
      headers: [
        {
          value: "name",
          text: "שם",
          align: "center",
        },
        {
          value: "id_number",
          text: "ח.ט",
          align: "center",
        },
        {
          value: "email",
          text: "מייל",
          align: "center",
        },
        {
          value: "company_phone",
          text: "מספר טלפון",
          align: "center",
        },
        {
          value: "fax",
          text: "מספר פקס",
          align: "center",
        },
        {
          value: "country",
          text: "עיר",
          align: "center",
        },
        {
          value: "address",
          text: "כתובת",
          align: "center",
        },
        {
          value: "status",
          text: "סטטוס",
          align: "center",
        },
        {
          value: "created_at",
          text: "תאריך הוספה",
          align: "center",
        },
      ],
      items: [],
    };
  },
  components: {
    DeleteDialog,
  },
  methods: {
    select_all_permissions(item, ev) {
      if (ev) {
        const map = this.permissions.map(function (val) {
          return val.value;
        });
        item.permissions = Object.assign([], map);
      } else {
        item.permissions = [];
      }
    },
    input_change(item, type) {
      this.$set(item, `${type}`, false);
    },
    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "super/companies",
            method: "get",
          },
        })
        .then((res) => {
          this.$emit("data_loaded");
          
          this.items = Object.assign([], res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    edit_row(item) {
      this.$emit("close_form");
      this.items.forEach((e) => {
        e.form = false;
      });
      item.form = true;
    },
    save_update(item) {
      if (this.$refs[`form_${item.id}`].validate() && !item.save_loader) {
        item.save_loader = true;
        this.$store
          .dispatch("public__request", {
            config: {
              url: `super/companies/${item.id}`,
              method: "put",
            },
            data: item,
          })
          .then((res) => {
            item.save_loader = false;
            this.snackbar_success = true;
            this.get_data();
          })
          .catch((err) => {
            item.save_loader = false;
            let errors = err.response.data.data;
            console.log(err.response);
            Object.keys(errors).forEach((e) => {
              errors[e].forEach((s) => {
                if (s.includes("already been taken")) {
                  this.$set(item, `${e}_exist`, true);
                }
              });
            });
          });
      }
    },
    delete_row(id) {
      this.delete_obj.id = id;
      this.delete_obj.delete_prop = true;
    },
    get_features() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: "super/features",
            method: "get",
          },
        })
        .then((res) => {
          this.features = Object.assign([], res.data.data);
        });
    },
  },
  mounted() {
    this.get_data();
    this.get_features();
  },
};
</script>

<style lang="scss" scoped>
.basic {
  .col:not(.col-12) {
    flex: 0 0 20%;
    max-width: 20%;
    @media (max-width: 991px) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }
}
</style>
